import { noop } from '@ajaibid/utils';
import {
  getDetailMFTransactionDeposit,
  getDetailMFTransactionWithdraw,
  getSearchMF,
} from '@services/api/platform/mutual-fund';
import { PopUpCenterV2 } from 'Component/PopUp';
import { SkeletonLoad } from 'Component/Skeleton';
import { bool, object, func } from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { Badge } from '@ajaibid/components';
import Accordion from 'Component/Accordion';
import { getSearchFaq } from '@services/api/platform/faq';
import StepProgress from '../StepperProgress';
import {
  styBottomTextCard,
  styContainerCardMF,
  styContainerMF,
  styModal,
  styTopTextCard,
} from './style';

const ModalStatusMF = ({ item, show, onClose }) => {
  const [mfTransactionDetail, setMfTransactionDetail] = useState(null);
  const [detailMF, setDetailMF] = useState([]);
  const [faq, setFaq] = useState([]);
  const dataDetail = detailMF?.find((data) => data?.fund_id === mfTransactionDetail?.fund?.id);

  const fetchMFDeposit = useCallback(
    async (id) => {
      const response = await getDetailMFTransactionDeposit(id);
      if (response) setMfTransactionDetail(response);
      if (response) {
        const mfDetail = await getSearchMF(response?.fund?.name);
        setDetailMF(mfDetail.results || []);
      }
    },
    [getDetailMFTransactionDeposit]
  );

  const fetchMFWithdraw = useCallback(
    async (id) => {
      const response = await getDetailMFTransactionWithdraw(id);
      if (response) setMfTransactionDetail(response);
      if (response) {
        const mfDetail = await getSearchMF(response?.fund?.name);
        setDetailMF(mfDetail.results || []);
      }
    },
    [getDetailMFTransactionWithdraw]
  );

  const fetchFaq = useCallback(async () => {
    const response = await getSearchFaq('Transaksi Reksa Dana');
    if (response) {
      const faqData = response?.map((v) => {
        return {
          title: v?.question,
          body: v?.answer,
        };
      });
      setFaq(faqData);
    }
  }, [getSearchMF]);

  useEffect(() => {
    setFaq(null);
    fetchFaq();
    setMfTransactionDetail(null);
    if (item?.type === 'deposit') fetchMFDeposit(item.transaction[0]?.id);
    if (item?.type === 'withdraw') fetchMFWithdraw(item.transaction[0]?.id);
  }, [item]);

  return (
    <PopUpCenterV2
      show={show}
      onHide={onClose}
      title="Status Transaksi Reksa Dana"
      className={styModal}
      containerClassName={styModal}
    >
      <div className={styContainerMF}>
        <div className={styContainerCardMF}>
          {!detailMF ? (
            <>
              <SkeletonLoad height={40} />
              <SkeletonLoad top={16} height={40} />
            </>
          ) : (
            <>
              <div style={{ display: 'flex' }}>
                {!dataDetail?.manager_image && !dataDetail?.image ? (
                  <SkeletonLoad height={40} width={40} circle borderRadius="100px" />
                ) : (
                  <img
                    src={dataDetail?.manager_image || dataDetail?.image}
                    alt=""
                    width={40}
                    height={40}
                    style={{ borderRadius: '100px' }}
                  />
                )}

                {!mfTransactionDetail ? (
                  <>
                    <SkeletonLoad height={40} />
                    <SkeletonLoad top={16} height={40} />
                  </>
                ) : (
                  <div style={{ marginLeft: 8 }}>
                    <div className={styTopTextCard}>
                      {mfTransactionDetail?.fund?.fund_bundle_name ||
                        mfTransactionDetail?.fund?.name}
                    </div>
                    <div className={styBottomTextCard}>{mfTransactionDetail?.fund?.name}</div>
                  </div>
                )}
              </div>
              <div style={{ maxWidth: 84 }}>
                {item?.type === 'withdraw' ? (
                  <Badge type="Order" orderVariant="Sell" />
                ) : (
                  <Badge
                    type="Order"
                    orderVariant="BUY"
                    textBuy={item?.source === 'AUTO_ORDER' ? 'Auto Beli' : 'Beli'}
                  />
                )}
              </div>
            </>
          )}
        </div>
        <div style={{ fontWeight: 800, marginBottom: 12, marginTop: 16 }}>Status</div>
        {!mfTransactionDetail ? (
          <>
            <SkeletonLoad height={40} />
            <SkeletonLoad top={16} height={40} />
          </>
        ) : (
          mfTransactionDetail?.status_changes?.map((v, index) => (
            <StepProgress
              typeTrans={item?.type}
              index={index}
              key={`step-${index}`}
              status={v.status}
              date={v.time}
              length={mfTransactionDetail?.status_changes?.length}
              step={v}
              noStatus={mfTransactionDetail.status}
              cancellationStatus={mfTransactionDetail?.cancellation_status}
            />
          ))
        )}
        <Accordion data={faq} defaultOpen={0} />
      </div>
    </PopUpCenterV2>
  );
};

ModalStatusMF.propTypes = {
  item: object,
  show: bool,
  onClose: func,
};

ModalStatusMF.defaultProps = {
  item: {},
  show: false,
  onClose: noop,
};

export default ModalStatusMF;
